import Phaser from 'phaser';
import { GAME_CONFIG } from './config/game.config';

// Initialize Phaser game
const game = new Phaser.Game(GAME_CONFIG);

// Handle window resize
window.addEventListener('resize', () => {
  game.scale.resize(window.innerWidth, window.innerHeight);
});

// Expose game instance for debugging in development
if (import.meta.env.DEV) {
  (window as any).__PHASER_GAME__ = game;
}

// Listen for debug pause/resume from parent debug.html
// This works in both DEV and PROD when accessed via debug.html (which adds ?debugPlayer=X)
const isDebugSession = new URLSearchParams(window.location.search).has('debugPlayer');
if (isDebugSession) {
  window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'DEBUG_PAUSE') {
      console.log('DEBUG_PAUSE received:', event.data.paused);
      if (event.data.paused) {
        game.loop.sleep();
        // Also pause sounds if any
        game.sound.pauseAll();
      } else {
        game.loop.wake();
        game.sound.resumeAll();
      }
    }
  });
}
